<template>
  <div class="torneo-context-bar">
    <!-- IZQUIERDA -->
    <div class="left mr-8">
      <v-icon small class="mr-2" color="green" dark>mdi-trophy</v-icon>
      <span class="titulo"> {{ sistemaCompetencia }} {{ nombre }} </span>
    </div>

    <span v-if="deporte !== 'Futbol'" class="torneo-configurado">
      {{ deporte }} - {{ tipoCompetencia }} - {{ genero }} - {{ categoria }}
    </span>

    <span v-else class="torneo-configurado">
      {{ deporte }} - {{ genero }}
    </span>

    <v-spacer></v-spacer>

    <!-- DERECHA -->
    <div class="right">
      <!-- Guardar -->
      <v-btn dark small class="mr-2" color="#24232d" @click="$emit('volver')">
        <v-icon left>mdi-arrow-left</v-icon>
        Volver
      </v-btn>
      <v-btn
        small
        color="success"
        class="mr-2"
        :disabled="!hayCambiosSinGuardar"
        @click="$emit('guardar')"
      >
        <v-icon left small>mdi-content-save</v-icon>
        Guardar
      </v-btn>

      <!-- Cambiar estado -->
      <v-menu offset-y v-if="estado !== 'Finalizado'">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            outlined
            color="indigo"
            class="mr-2"
            dark
            v-bind="attrs"
            v-on="on"
            @click="$emit('cambiar-estado')"
          >
            <v-icon left small>mdi-sync</v-icon>
            Estado
          </v-btn>
        </template>
        <v-list dense class="estado-menu">
          <v-list-item
            v-if="estado === 'Publicado'"
            class="menu-item draft"
            @click="cambiarEstado('Draft')"
          >
            <v-list-item-icon>
              <v-icon small color="warning">mdi-pencil</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Volver a Draft</v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="estado === 'Draft'"
            class="menu-item publicar"
            @click="cambiarEstado('Publicado')"
          >
            <v-list-item-icon>
              <v-icon small color="success">mdi-earth</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Publicar</v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="estado === 'Publicado'"
            class="menu-item finalizar"
            @click="cambiarEstado('Finalizado')"
          >
            <v-list-item-icon>
              <v-icon small color="error">mdi-flag-checkered</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Finalizar</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <!-- Chip estado -->
      <v-chip small :color="getColor()" dark>
        {{ estado }}
      </v-chip>
    </div>
  </div>
</template>

<script>
import axios from "@/axios-auth";
import { confirmModal } from "@/utils/toast";

export default {
  name: "TorneoContextBar",
  props: {
    nombre: {
      type: String,
      required: true,
    },
    estado: {
      type: String,
      required: true,
    },
    hayCambiosSinGuardar: {
      type: Boolean,
      required: true,
    },
    tipoCompetencia: {
      type: String,
    },
    genero: {
      type: String,
    },
    categoria: {
      type: String,
    },
    idTorneo: {
      type: [Number, String],
    },
    idInstitucion: {
      type: [Number, String],
    },
    campeon: {
      type: Object,
    },
    sistemaCompetencia: {
      type: String,
    },
    deporte: {
      type: String,
    },
  },
  methods: {
    async cambiarEstado(estado) {
      if (estado === "Finalizado") {
        this.$emit("finalizaTorneo");
        return;
      }
      const datosTorneo = {
        nombre: "",
        descripcion: "",
        genero: null,
        categoria: null,
        fecha: "01/01/2025",
        tipoCompetencia: null,
        estado,
        configuraciones: "",
        idTorneo: this.idTorneo,
        idInstitucion: this.idInstitucion,
      };
      try {
        await axios.post("/Torneos/CambiarEstado", datosTorneo);
        this.$emit("cambiarEstado", estado);
      } catch (error) {
        console.log(error);
      }
    },
    getColor() {
      if (this.estado === "Draft") return "warning";
      if (this.estado === "Publicado") return "success";
      return "error";
    },
  },
};
</script>

<style lang="scss" scoped>
.torneo-context-bar {
  display: flex;
  align-items: center;
  padding: 8px 16px;

  backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.left {
  display: flex;
  align-items: center;
}

.right {
  display: flex;
  align-items: center;
}

.titulo {
  font-weight: 700;
  font-size: 1.2rem;
  color: black;
}
.torneo-configurado {
  border: 1px solid orange;
  border-radius: 5px;
  padding: 0.5rem 1rem;
  background: oldlace;
  color: black;
  font-size: 16px;
}
.estado-menu {
  padding: 0;
  overflow: hidden;
}
.menu-item {
  display: flex;
  align-items: center;
  cursor: pointer;
  :deep(.v-list-item__icon) {
    margin: 0;
    margin-right: 0.1rem;
    height: 40px;
  }
  &:hover {
    background-color: antiquewhite;
  }
}
</style>
